export default __webpack_public_path__ + "static/media/3.38e6e7f4.png";